import server from "../../../server";


export async function fetchSummary(employeeId:string) {
    const res=await server.attendance.employee.getAttendanceSummary(employeeId);
    return res;
}

export async function fetchMyAttendance(employeeId:string,pageNumber:number,pageSize?:number,startDate?:string,endDate?:string,sortField?:string,sortDirection?:string,status?:string){
    const res=await server.attendance.employee.list(employeeId,pageNumber,pageSize??10,startDate,endDate,sortField,sortDirection,status);
    return res;
}

export async function fetchPunches(employeeId:string,pageNumber:number,pageSize?:number,startDate?:string,endDate?:string) {
 const res=await server.attendance.employee.punchList(employeeId,pageNumber,pageSize,startDate,endDate);
 return res;
}
